module.exports = __webpack_public_path__ + "img/3_ku.33bf1273.jpg";